import { Grid, Typography } from "@mui/material";
import { Spinner } from "../../components/Loading/Spinner";
import { useSuperAdminPlans } from "../../context/SuperAdmin/PlanContext";
import PlansPanel from "../../components/Table/Plan/PlansPanel";
import SuscrPickOrg from "../../components/Profile/SuscrPickOrg";
import { useAuthContext } from "../../hooks/Auth";

const PlansPage = () => {
  const { isLoadingOrgs, orgs, selectedOrg, handleSelectChange } =
    useSuperAdminPlans();

  const { canAccess } = useAuthContext();

  const isSuperAdmin = canAccess("view:plans");

  return (
    <Grid
      container
      spacing={4}
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        pt: 3,
      }}
    >
      {/* Título */}
      <Grid item>
        <Typography variant={"h4"} sx={{ color: "#005559", fontSize: "30px" }}>
          <b>Suscripciones & Planes</b> | Planes
        </Typography>
      </Grid>

      {isLoadingOrgs ? (
        <Grid item>
          <Spinner msg="Cargando por favor espere..." />
        </Grid>
      ) : (
        <>
          {/* Seleccionar organizacion */}
          {isSuperAdmin && (
            <Grid item>
              <SuscrPickOrg
                organizaciones={orgs}
                selectedOrg={selectedOrg ? selectedOrg : ""}
                handleChange={handleSelectChange}
                isLoading={isLoadingOrgs}
              />
            </Grid>
          )}

          {/* Menú de roles */}
          {selectedOrg && <PlansPanel />}
        </>
      )}
    </Grid>
  );
};

export default PlansPage;
